import React from "react";

import { BaseContainer, StepCard } from "src/components";

const EsgContainer = ({ maxWidth = "690px", children }) => {
  return (
    <BaseContainer>
      <div
        className="w-100 mx-auto mt-4 d-flex flex-column align-items-left position-relative"
        style={{ maxWidth }}
      >
        <StepCard>
          <div className="px-2 py-3 text-center">{children}</div>
        </StepCard>
      </div>
    </BaseContainer>
  );
};

export default EsgContainer;
